module.exports = __webpack_public_path__ + "img/blue_090.0d9b112b.png";